// IMPORT REACT
import React from 'react';

import YAText from '../Text';

// IMPORT STYLES
import { SC_Embed, SC_Iframe } from './styles';


const YAEmbed = (props) => {

  return (
  	<SC_Embed>
  		<SC_Iframe {...props} />
  	</SC_Embed>
  )
    
}
export default YAEmbed;